import { WarningErrorIcon } from "vega-icons";

import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { m } from "@vega-core/paraglide/messages";

type Props = {
  testId: string;
  onRetry: () => void;
  isRetrying?: boolean;
  title?: string;
  description?: string;
};

export const MessagingErrorState = ({
  testId,
  onRetry,
  isRetrying = false,
  title = m.coInvestments_messages_error_title(),
  description = m.coInvestments_messages_error_subtitle(),
}: Props) => (
  <div
    className="flex flex-col items-center justify-center gap-3 px-6 py-10 text-center"
    data-testid={testId}
    role="alert"
  >
    <WarningErrorIcon
      aria-hidden="true"
      className="h-8 w-8 text-text/secondary"
    />
    <p className="body-base-semibold text-text/primary">{title}</p>
    <p className="body-small-regular text-text/secondary">{description}</p>
    <ThemedButton
      dataTestId={`${testId}-retry`}
      disabled={isRetrying}
      onClick={onRetry}
      variant="secondary"
    >
      {m.coInvestments_messages_error_retry()}
    </ThemedButton>
  </div>
);
